export default __webpack_public_path__ + "static/media/10.96a39654.jpg";